"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BRANCH_HOLIDAY_LIST_MAX_RANGE_YEARS () {
        return BRANCH_HOLIDAY_LIST_MAX_RANGE_YEARS;
    },
    get BRANCH_HOLIDAY_REASON_MAX_LENGTH () {
        return BRANCH_HOLIDAY_REASON_MAX_LENGTH;
    },
    get BranchHolidayCreateRequestSchema () {
        return BranchHolidayCreateRequestSchema;
    },
    get BranchHolidayListQuerySchema () {
        return BranchHolidayListQuerySchema;
    },
    get BranchHolidayListResponseSchema () {
        return BranchHolidayListResponseSchema;
    },
    get BranchHolidaySchema () {
        return BranchHolidaySchema;
    },
    get addYearsToCalendarDate () {
        return addYearsToCalendarDate;
    },
    get resolveBranchHolidayRange () {
        return resolveBranchHolidayRange;
    }
});
const _zod = require("zod");
const BRANCH_HOLIDAY_REASON_MAX_LENGTH = 200;
const BRANCH_HOLIDAY_LIST_MAX_RANGE_YEARS = 2;
const BranchHolidaySchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    branchId: _zod.z.string().uuid(),
    date: _zod.z.iso.date(),
    reason: _zod.z.string().min(1).max(BRANCH_HOLIDAY_REASON_MAX_LENGTH).nullable(),
    createdAt: _zod.z.string().datetime({
        offset: true
    })
}).strict();
const BranchHolidayListResponseSchema = _zod.z.object({
    items: _zod.z.array(BranchHolidaySchema)
}).strict();
const BranchHolidayCreateRequestSchema = _zod.z.object({
    date: _zod.z.iso.date({
        message: 'Date must be a calendar date (YYYY-MM-DD).'
    }),
    reason: _zod.z.string({
        message: 'Reason must be text.'
    }).trim().max(BRANCH_HOLIDAY_REASON_MAX_LENGTH, {
        message: `Reason must be ${BRANCH_HOLIDAY_REASON_MAX_LENGTH} characters or fewer.`
    }).nullish().transform((value)=>{
        if (value === null || value === undefined || value === '') {
            return null;
        }
        return value;
    })
}).strict();
const BranchHolidayListQuerySchema = _zod.z.object({
    from: _zod.z.iso.date().optional(),
    to: _zod.z.iso.date().optional()
}).strict();
function pad(value, width) {
    return String(value).padStart(width, '0');
}
function addYearsToCalendarDate(date, years) {
    const year = Number(date.slice(0, 4)) + years;
    const month = Number(date.slice(5, 7));
    const day = Number(date.slice(8, 10));
    const daysInMonth = new Date(Date.UTC(year, month, 0)).getUTCDate();
    return `${pad(year, 4)}-${pad(month, 2)}-${pad(Math.min(day, daysInMonth), 2)}`;
}
function resolveBranchHolidayRange(query, today) {
    const from = query.from ?? today;
    const to = query.to ?? null;
    if (to === null) {
        return {
            from,
            to
        };
    }
    if (to < from) {
        return null;
    }
    if (to > addYearsToCalendarDate(from, BRANCH_HOLIDAY_LIST_MAX_RANGE_YEARS)) {
        return null;
    }
    return {
        from,
        to
    };
}
